var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pointer cannotselect margin-top-l margin-left-l",on:{"click":_vm.popup}},[_vm._v("弹出")]),_vm._v(" "),_c('popup-menu',{ref:"child",attrs:{"menuData":_vm.menuData},on:{"menuClick":function($event){return _vm.menuClick(arguments)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50208e83","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Detail.vue
// module id = null
// module chunks = 